import { connect } from "react-redux";

import Topic from "./components/Topic";
import CarouselAd from "./components/Carousel";
import List from "./components/List";
import Recommend from "./components/Recommend";
import { HomeWrapper, HomeLeft, HomeRight } from "./style";
import back from "statics/back.png";

const Home = (props) => {
  return (
    <>
      <CarouselAd />
      <Topic />
      <List />
    </>
  );
};

const mapDispatch = (dispatch) => ({});

export default connect(null, mapDispatch)(Home);
